import styled from "styled-components";
import Image from "next/image";

const Section = styled.section<{ orientation: "left" | "right"; centerMedia: boolean }>`
    padding: 0 15px;
    display: flex;

    & > div {
        width: 50%;
    }

    img {
        max-width: 100%;
    }

    .info {
        padding: ${({ orientation }) => (orientation === "right" ? "0 100px 0 60px" : "0 60px 0 100px")};
    }

    .info header {
        font-weight: bold;
        font-size: 1.5rem;
        border-bottom: 4px solid #FF5701;
        padding: 1rem 0 0.5rem 0;
        margin-bottom: 1rem;
    }

    p, li {
        color: #3e3e3e;
        margin-bottom: 1rem;
        font-size: 1rem;
    }

    ul {
        padding-left: 20px;
    }
    ul li {
        list-style: disc;
    }

    @media (max-width: 800px) {
        flex-direction: ${({ orientation }) => (orientation === "left" ? "column" : "column-reverse")};
        padding: 0;

        .info {
            padding: 0 15px;
        }

        .media {
            ${({ centerMedia = false, orientation }) => (centerMedia ? (
                `padding: 0 15px;`
            ) : (
                `padding-${orientation}: 15px;`
            ))}
        }

        .media img {
            ${({ centerMedia = false, orientation }) => (centerMedia ? (
                `border-radius: 20px;`
            ) : (
                `
                    border-top-${orientation}-radius: 20px;
                    border-bottom-${orientation}-radius: 20px;
                `
            ))}
        }

        .media img {
            border-top-${({ orientation }) => orientation}-radius: 20px;
            border-bottom-${({ orientation }) => orientation}-radius: 20px;
        }

        & > div {
            width: 100%;
        }
    }
`;

type InformationLineProps = {
    id?: string;
    header: string | any;
    mediaUrl?: any;
    mediaAlt?: string;
    orientation?: "left" | "right";
    centerMedia?: boolean;
    mediaStyle?: React.CSSProperties;
    media?: () => any;
    children: any;
};

const InformationLine: React.FC<InformationLineProps> = ({ header, media, mediaUrl, children, id = "", mediaStyle = {}, centerMedia = false, orientation = "left", mediaAlt = "" }) => {
    return (
        <Section orientation={orientation} centerMedia={centerMedia} className="container">
            {orientation === "left" ? (
                <div className="info">
                    <header id={id}>
                        {header}
                    </header>

                    <main>
                        {children}
                    </main>
                </div>
            ) : (
                <div className="media" style={mediaStyle}>
                    {media ? media() : <Image src={mediaUrl} alt={mediaAlt} />}
                </div>
            )}

            {orientation === "left" ? (
                <div className="media" style={mediaStyle}>
                    {media ? media() : <Image src={mediaUrl} alt={mediaAlt} />}
                </div>
            ) : (
                <div className="info">
                    <header id={id}>
                        {header}
                    </header>

                    <main>
                        {children}
                    </main>
                </div>
            )}
        </Section>
    );
};

export default InformationLine;
